'use client';

import type { CustomerProps } from '@/repositories/auth/AuthRepository.types';
import type { Translate } from 'next-translate';
import { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useAuth } from '@/contexts/AuthContext';
import { useConfig } from '@/contexts/ConfigContext';
import { useTheme } from '@/contexts/ThemeContext';
import { capitalizeFirstLetter } from '@/utils/string';
const useHeaderViewModel = () => {
  const {
    t
  } = useTranslation('common');
  const {
    user
  } = useAuth();
  const {
    isMobile
  } = useConfig();
  const {
    isDarkMode
  } = useTheme();
  const [greetings, setGreetings] = useState('');
  useEffect(() => {
    setGreetings(() => mountGreetings({
      user,
      t
    }));
  }, [user, t]);
  return {
    greetings,
    isDarkMode,
    isMobile
  };
};
const mountGreetings = ({
  user,
  t
}: GetGreetingParams) => {
  const time = new Date().getHours();
  const userName = user?.name.trim();
  const firstName = !userName ? '' : capitalizeFirstLetter(userName.split(' ')[0]);
  if (time > 18) {
    return `${t('greetings.goodEvening')}, ${firstName}`;
  }
  if (time > 12) {
    return `${t('greetings.goodAfternoon')}, ${firstName}`;
  }
  return `${t('greetings.goodMorning')}, ${firstName}`;
};
type GetGreetingParams = {
  user: CustomerProps | null;
  t: Translate;
};
export default useHeaderViewModel;